import { render, staticRenderFns } from "./NflTicker.vue?vue&type=template&id=192c7d62"
import script from "./NflTicker.vue?vue&type=script&lang=js"
export * from "./NflTicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports